import Handler from "../Handler";

class NextGameTimerHandler extends Handler {
  execute(message) {
    this.service.processNextGameTimer();
  }
}

export default NextGameTimerHandler;
